import { Reveal, ChapterHead } from "./Reveal";
import { useContent } from "@/content";

export const Technology = () => {
  const c = useContent();

  return (
    <section id="technology" className="px-6 sm:px-12 lg:px-20 py-24 sm:py-32 max-w-7xl mx-auto" data-testid="technology-section">
      <ChapterHead index="CHAPTER 04" title="TECHNOLOGY" />

      <Reveal>
        <p className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight leading-tight max-w-5xl">
          {c.technology_headline || "Technology should extend human capability — not quietly decide how humans think."}
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10 mt-14 sm:mt-20">
        <Reveal className="bg-[#0A0A0A] p-8 sm:p-12">
          <p className="font-meta text-xs tracking-[0.3em] text-neutral-500 mb-6">WHAT IT CAN EXPAND</p>
          <ul className="space-y-4">
            {["CREATIVITY", "COMMUNICATION", "EDUCATION", "ORGANIZATION", "POSSIBILITY"].map((i) => (
              <li key={i} className="font-display text-xl sm:text-2xl font-bold uppercase tracking-tight flex items-center gap-4">
                <span className="w-6 h-px bg-white/40" /> {i}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal className="bg-[#0A0A0A] p-8 sm:p-12" delay={0.1}>
          <p className="font-meta text-xs tracking-[0.3em] text-neutral-500 mb-6">WHAT IT CAN ERODE</p>
          <ul className="space-y-4">
            {["ATTENTION", "INDEPENDENT THINKING", "CURIOSITY", "EMOTIONAL INTELLIGENCE", "INDIVIDUALITY"].map((i) => (
              <li key={i} className="font-display text-xl sm:text-2xl font-bold uppercase tracking-tight flex items-center gap-4 text-neutral-400">
                <span className="w-6 h-px bg-white/20" /> {i}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <p className="text-base sm:text-lg font-light leading-relaxed text-neutral-300 mt-14 max-w-3xl">
          {c.technology_text || "Artificial intelligence, algorithms, and digital systems will keep expanding. That is not the threat by itself — the threat is using them without awareness. As machines take on more of what humans used to do, the things machines cannot replace become more valuable: creativity, critical thought, consciousness, and the courage to use technology deliberately instead of being used by it."}
        </p>
      </Reveal>
    </section>
  );
};
